import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { TripService } from 'src/app/services/trip.service';

@Component({
	selector: 'nr-trip-list-modal',
	templateUrl: './trip-list-modal.component.html',
	styleUrls: ['./trip-list-modal.component.scss'],
	imports: [
		CommonModule,
		IonicModule,
		TranslateModule,
	],
})
export class TripListModalComponent {
	constructor(
		public tripService: TripService,
		private modalCtrl: ModalController
	) {
	}

	addTrip() {
		this.tripService.openAddTripModal(this.modalCtrl);
	}

	cancel() {
		return this.modalCtrl.dismiss(null, 'cancel');
	}

	confirm(tripId: number) {
		return this.modalCtrl.dismiss(tripId, 'confirm');
	}
}
